import { type FC } from "react";

import { StatusCell } from "../../../../common/components/table/StatusCell";
import { lensStatusLabelMap } from "../../constants/lensStatusLabelMap";

interface LensStatusCellProps {
    status?: string;
}
export const LensStatusCell: FC<LensStatusCellProps> = ({ status }) => (
    <StatusCell status={status ?? ""} statusMap={lensStatusLabelMap} />
);
